import { startWith, takeUntil } from 'rxjs/operators';

import { SnLocation } from '@lib/api/entities';
import { colorIsDark } from '@lib/common/helpers';
import { COLORS } from '@lib/ui/theme';
import { GoogleMapMarker, GoogleMapMarkerType } from '@lib/geo/google/map';

export class LocationMarker extends GoogleMapMarker {
  constructor(public readonly location: SnLocation) {
    super({
      id: `location-${location.id}`,
      lonLat: location?.geometry?.coordinates,
      type: GoogleMapMarkerType.PIN,
      icon: {
        fontSet: 'fs',
        fontIcon: location.type?.icon,
        color: colorIsDark(location.type?.color) ? COLORS['grey-0'] : '#000000',
      },
      style: {
        strokeColor: location.type?.color,
        fillColor: location.type?.color,
        rotation: 0,
      },
    });
  }

  protected onAdd(): void {
    this.map
      .on('zoomChange')
      .pipe(startWith(this.map.getZoom()), takeUntil(this.on('remove')))
      .subscribe((zoom) => {
        if (zoom >= 19) {
          this.setLabel({
            text: this.location.name,
            color: this.map.getStyle() === 'dark' ? COLORS['grey-0'] : '#000000',
          });
        } else {
          this.setLabel(null);
        }
      });

    super.onAdd();
  }
}
